import { NotFoundLayout } from 'components/internal/NotFound';
import { useLotteryWinModal } from 'hooks/lotteryWinModal';
import { GlobalTooltip } from 'modules/globalTooltip';
import nprogress from 'nprogress';
import type { FC } from 'react';
import { useEffect } from 'react';
import { NotFoundBoundary, useLoadingRoute } from 'react-navi';

import 'nprogress/nprogress.css';

const useLoadingBar = () => {
  const routeLoading = !!useLoadingRoute();

  useEffect(() => {
    nprogress.configure({
      parent: 'body',
      easing: 'ease-in-out',
      speed: 400,
      showSpinner: false,
    });

    return () => {
      nprogress.remove();
    };
  }, []);

  useEffect(() => {
    if (routeLoading) {
      nprogress.start();

      const interval = setInterval(() => {
        nprogress.inc(0.3 * Math.cos((nprogress.status || 0) * (Math.PI / 2)));
      }, 300);

      return () => clearInterval(interval);
    }
    nprogress.done();
  }, [routeLoading]);

  return routeLoading;
};

export const Layout: FC = ({ children }) => {
  useLoadingBar();

  useLotteryWinModal();

  return (
    <>
      <GlobalTooltip />
      <NotFoundBoundary render={NotFoundLayout}>{children}</NotFoundBoundary>
    </>
  );
};
